// activation behaviour — activation-state classes the framework toggles at runtime
// (e.g. the selected option in selectButtons, the active tab). cleanSlate uses one
// neutral state class, .zit-cs-active, which composes with a component's base class
// to produce the selected look (see .zit-cs-filter-btn.zit-cs-active in index.css).
// A component's server-rendered initial state must use the same class so it matches
// what the JS toggles. 'disabled' is wired for completeness; unknown states throw.
const activation = {
    stateClass: function (name) {
        const tokens = { active: 'zit-cs-active', disabled: 'zit-cs-disabled' };
        const token = tokens[name];

        if (typeof token === typeof undefined) {
            throw new Error('zit activation.stateClass: unknown state "' + name + '"');
        }

        return token;
    }
};

export default activation;
